import { type TCfContext } from '../../types/cfContextTypes'
import { getCookiesPolicy } from '../cookiesPolicy'
import { getCountryCodeFromCookie } from '../getCountryCodeFromCookie'
import { isEuCountry } from '../isEuCountry'

export const stripIpWithoutConsent = (cf: TCfContext): TCfContext => {
    if (!isEuCountry(getCountryCodeFromCookie()) || getCookiesPolicy() === 'allowed') {
        return cf
    }

    const withoutIp = { ...cf }
    delete withoutIp.client_ip

    return withoutIp
}
